import { FC } from 'react';
import { MuiTrackerButton } from './TrackerButtonWrapper';
import { ButtonName } from '../constants';
import logger from '../services/loggerManager';
import { useAuth0 } from '@auth0/auth0-react';
import { useIdleTimerContext } from 'react-idle-timer';

interface MainFlowStartActionsProps {}
export const MainFlowStartActions: FC<MainFlowStartActionsProps> = () => {
  const { loginWithRedirect } = useAuth0();
  const { activate } = useIdleTimerContext();

  const handleStartClick = () => {
    logger.log('Start button click', {
      filename: 'MainFlowStartActions.tsx',
      function: 'handleStartClick',
    });
    activate();
    loginWithRedirect();
  };

  return (
    <>
      <MuiTrackerButton
        buttonName={ButtonName.Start}
        variant="contained"
        color="primary"
        size="large"
        onClick={handleStartClick}
        data-testid="start-btn"
      >
        Start
      </MuiTrackerButton>
    </>
  );
};
